import loadScript from '@/utils/dynamicLoadScript';
import { insertJs } from '@/utils';
export default function initZiggeo() {
  return new Promise((resolve, reject) => {
    insertJs('link', ['https://assets.ziggeo.com/v2-stable/ziggeo.css']);
    loadScript('ZiggeoApi', 'https://assets.ziggeo.com/v2-stable/ziggeo.js', err => {
      if (err) {
        console.error(err);
        reject(err);
      } else {
        resolve();
      }
    });
  });
}
